.link {
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  padding: 18px;
  border-radius: 5px;
  border: 1px solid var(--colors-lightgray);
  margin-bottom: 12px;
}
